import { usePatient } from "@/context/PatientContext";
import TimelineFeed from "@/components/TimelineFeed";
import { ClockCounterClockwise } from "@phosphor-icons/react";

export default function Timeline() {
  const { activePatient } = usePatient();
  if (!activePatient) return <div className="text-[#576A62]">Add a patient first.</div>;
  return (
    <div className="space-y-8">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-[#576A62] font-semibold">History</div>
        <h1 className="mt-2 font-heading text-3xl sm:text-4xl font-bold flex items-center gap-3">
          <ClockCounterClockwise size={32} weight="duotone" className="text-[#2C5545]" />
          Activity timeline
        </h1>
        <p className="mt-2 text-[#576A62]">
          Everything the care team has done for <span className="font-semibold">{activePatient.name}</span>.
        </p>
      </div>
      <div className="bg-white border border-[#EBE8E0] rounded-2xl p-4 sm:p-6">
        <TimelineFeed patientId={activePatient.id} limit={200} />
      </div>
    </div>
  );
}
